module.exports = __webpack_public_path__ + "static/media/7.3cf5f873.JPG";